export enum DataFolderOrigin {
    List,
    Processed,
    Deleted,
    Error
}